// extracted by mini-css-extract-plugin
export default {"modal-container":"modal_modal-container__g4xnJ","title":"modal_title__EntG3"};